import { render, staticRenderFns } from "./datasource-chart.vue?vue&type=template&id=33e494fd&"
import script from "./datasource-chart.vue?vue&type=script&lang=js&"
export * from "./datasource-chart.vue?vue&type=script&lang=js&"
import style0 from "./datasource-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports